import { CompanyTitledPage } from "../../TitledPage";

import { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

import { OutlinedInput } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

import { SYSTEM_PATH_COMPANY } from "../../../App";
import { CompanyPartHeader } from "../../../components/PartHeader";
import { searchCustomerInfoList } from "../../../http/api/CustomerAPI";

const getCustomerLocationState = (customerId) => ({ customerId });

// 検索フォーム
function CustomerSearchForm(props) {
  // テキストボックス　フォーカス時に全選択する
  const onFocusInput = (event) => {
    event.target.select();
  };

  const [searchConditionInput, setSearchConditionInput] = useState({
    name: "",
  });

  const handleChangeSearchConditionInput = (searchProp) => (event) => {
    setSearchConditionInput({
      ...searchConditionInput,
      [searchProp]: event.target.value,
    });
  };

  const onClickSearch = (event) => {
    props.setSearchCondition(searchConditionInput);
  };

  return (
    <Box border="1px solid blue" borderRadius={1} padding={2}>
      取引先検索
      <Box margin={2} marginBottom={1}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs>
            取引先名:&nbsp;
            <OutlinedInput
              onFocus={onFocusInput}
              onChange={handleChangeSearchConditionInput("name")}
              value={searchConditionInput.name}
              sx={{ width: 250 }}
            />
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={onClickSearch}>
              検索
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

// 取引先検索結果表
// props...data = 表のデータ
function CustomerSearchResultTable(props) {
  const navigate = useNavigate();
  const [customerList, setCustomerList] = useState([]);

  useEffect(() => {
    searchCustomer(props.searchCondition);
  }, [props.searchCondition]);

  const searchCustomer = async (searchCondition) => {
    var name = searchCondition.name;
    // setCustomerList(SAMPLE_CUSTOMER_LIST.filter((data) => (data.name.indexOf(name) >= 0 || data.name_furigana.indexOf(toHiragana(name)) >= 0) && data.delete_flag === 0 ))
    let res = await searchCustomerInfoList({ customerName: name });
    setCustomerList(res.listCustomerInfo);
  };

  if (customerList.length > 0) {
    return (
      <TableContainer component={Box}>
        <Table>
          <TableBody>
            {customerList.map((data, i) => (
              <TableRow key={i}>
                <TableCell width={30}>
                  <Typography fontSize={18} textAlign="right">
                    {(i + 1).toString()}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item xs>
                      <Typography fontSize={15}>
                        {data.customerNameFurigana}
                      </Typography>
                      <Typography fontSize={20}>
                        <Link
                          to={SYSTEM_PATH_COMPANY + "/customer_information"}
                          state={getCustomerLocationState(data.customerId)}
                        >
                          {data.customerName}
                        </Link>
                      </Typography>
                    </Grid>
                    <Grid item xs="auto">
                      <Button
                        variant="outlined"
                        onClick={() => {
                          navigate("/company/order_form_confirm", {
                            state: {
                              customerId: data.customerId,
                            },
                          });
                        }}
                      >
                        市況価格表
                      </Button>
                    </Grid>
                    <Grid item xs="auto">
                      <Button
                        variant="outlined"
                        // onClick={() => {
                        //   navigate("/company/order_form_confirm", {
                        //     customerId: data.customerId,
                        //   });
                        // }}
                      >
                        注文履歴
                      </Button>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  return <Typography>検索条件に該当する店舗がありません</Typography>;
}

// 取引先情報表示ページ
export default function CustomerSearchPage() {
  const navigate = useNavigate();

  const [searchCondition, setSearchCondition] = useState({ name: "" });

  const onClickCustomerRegistration = (event) => {
    navigate(SYSTEM_PATH_COMPANY + "/customer_registration");
  };

  return (
    <CompanyTitledPage title="取引先検索">
      <CustomerSearchForm setSearchCondition={setSearchCondition} />
      <CompanyPartHeader>
        <Grid container>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              検索結果
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={onClickCustomerRegistration}>
              新規取引先を登録
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>
      <CustomerSearchResultTable searchCondition={searchCondition} />
    </CompanyTitledPage>
  );
}
